import React from 'react';
import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';

import RequirementTemplateBlueprintType from '../../../../types/RequirementTemplateBlueprintType';

import RequirementTemplateBuilderBodyLeft from './components/RequirementTemplateBuilderBodyLeft';
import RequirementTemplateBuilderHeaderLeft from './components/RequirementTemplateBuilderHeaderLeft';

function RequirementTemplateLeftBox({ blueprint }) {
  const showSideHeaders = useSelector(blueprint.selectShowSideHeaders);
  return (
    <Flex
      direction="column"
      h="100%"
      justifyContent="space-between"
      minH="75vh"
      minW="380px"
      w="380px"
    >
      {showSideHeaders && <RequirementTemplateBuilderHeaderLeft blueprint={blueprint} />}
      <RequirementTemplateBuilderBodyLeft blueprint={blueprint} />
    </Flex>
  );
}

RequirementTemplateLeftBox.propTypes = {
  blueprint: RequirementTemplateBlueprintType
};

export default RequirementTemplateLeftBox;
